(() => {
  const init = () => {
    const main = document.getElementById('MainContent');
    if (!main || main.dataset.beFooterSpacingReady) return;
    main.dataset.beFooterSpacingReady = 'true';

    // Follow layout containers only. Stop at content (cards, grids, sliders,
    // rich text, forms), so their internal padding and sizing stay intact.
    const wrappers = '.shopify-section, .be-search-top, #be-search-top, '
      + '[class*="section-"][class*="-padding"], .page-width:not(.rte), '
      + '.template-search, .facets-vertical, #ProductGridContainer, .collection, '
      + '#main-cart-footer, .cart__footer, .article-template, #related-item, product-recommendations, '
      + 'div.gradient, .shopify-policy__container';
    let marked = new Set();
    let frame = 0;
    const update = () => {
      frame = 0;
      const edges = new Set();
      const containers = new Set();
      let parent = main;
      while (parent) {
        const children = [...parent.children].filter(element => {
          const style = getComputedStyle(element);
          return !element.hidden && !element.matches('script, style, link, template')
            && style.display !== 'none' && style.visibility !== 'hidden'
            && !['absolute', 'fixed'].includes(style.position)
            && element.getBoundingClientRect().height > 0;
        });
        const last = children.at(-1);
        if (!last) break;
        edges.add(last);
        if (!last.matches(wrappers)) break;
        containers.add(last);
        // Recent is a complete content block, not a reason to trim its cards.
        if (last.matches('[data-recent-products]')) break;
        parent = last;
      }
      for (const element of marked) {
        if (!edges.has(element)) element.removeAttribute('data-be-footer-edge');
        if (!containers.has(element)) element.removeAttribute('data-be-footer-wrapper');
      }
      for (const element of edges) element.setAttribute('data-be-footer-edge', '');
      for (const element of containers) element.setAttribute('data-be-footer-wrapper', '');
      marked = edges;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    // Recent history, recommendations and filtering may replace the last block.
    new MutationObserver(records => {
      if (records.some(record => record.type === 'childList'
        || record.target === main || record.target.matches(wrappers))) schedule();
    }).observe(main, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['hidden', 'class', 'style']
    });
    // Apps may hide/reveal the whole page without changing its dimensions.
    const visibilityObserver = new MutationObserver(schedule);
    for (let ancestor = main.parentElement; ancestor; ancestor = ancestor.parentElement) {
      visibilityObserver.observe(ancestor, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    }
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    // CSS and app content can finish loading after the deferred initializer.
    if (typeof ResizeObserver === 'function') new ResizeObserver(schedule).observe(main);
    main.addEventListener('load', schedule, true);
    update();
  };
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init) : init();
})();
